/**
 * The index an arrow key moves to, wrapping at either end. `-1` is how a list
 * with nothing highlighted says so, and stepping from it reaches the last row
 * going up and the first going down, which the modulo spelling gets wrong. An
 * empty list answers `-1` too, since there is no row to be on.
 */
export function wrappedIndex(
  from: number,
  step: number,
  count: number,
): number {
  if (count === 0) return -1;
  const next = from + step;
  if (next < 0) return count - 1;
  return next >= count ? 0 : next;
}
